module.exports = __webpack_public_path__ + "static/img/equ5.b8a3dba4.jpg";